export default "__VITE_ASSET__BUrI4f_h__"